import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { fetchProductsGroups } from './fetchProductsGroups'
import { getUrlWithVersion } from '../../../../api/api'

export const editProductsGroup = createAsyncThunk<
    void,
    { groupId: string; data: any; cb?: () => void },
    ThunkConfig<string>
>('productsSlice/editProductsGroup', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { groupId, data, cb } = args

    try {
        await api.put(getUrlWithVersion(`/groups/${groupId}`), data)

        dispatch(fetchProductsGroups())
        throwSuccessMessage('Success!')

        if (cb && typeof cb === 'function') {
            cb()
        }
    } catch (e) {
        alertErrorMessage(e)
        dispatch(fetchProductsGroups())
        return rejectWithValue('Failed to edit group')
    }
})
